/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _filter from "lodash/filter";
import debounce from "es6-promise-debounce";
import { jsx, css } from "@emotion/core";
import { FiMenu, FiX } from "react-icons/fi";
import { FaChevronDown } from "react-icons/fa";
import logo from "../../../images/farmakom_logo.webp";

import {
  primary_light,
  primary_s15_l20,
  primary_s98_l83,
} from "../../lib/colors";
import Assistenza from "../../Icons/Assistenza";
import Spedizione from "../../Icons/Spedizione";
import Search from "../../Icons/Search";
import Login from "../HeaderMenu/Login/Login";
import LoginIcon from "../../Icons/Login";
import IndexLink from "../../IndexLink/IndexLink";
import Link from "../../Link/Link";
import AsyncSelect from "../../../shared/AsyncSelect/AsyncSelect";
import A from "../../Anchor/Anchor";
import Button from "../../Button/Button";
import Price from "../../Price/Price";
import MegaMenu from "./MegaMenu/MegaMenu";
import CartMenu from "./CartMenu/CartMenu";
import ProductAutocomplete from "../../ProductAutocomplete/ProductAutocomplete";

import "./HeaderMenu.scss";
// import api from "../../../../api";

const singleStore = () => {
  // console.log("ciao");
};
// import { singleStore } from "../../../../redux/modules/singleStore";

class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMegaMenuType: "",
      showMegaMenu: false,
      showCartMenu: false,
      showLogin: false,
    };
  }

  // GET CATEGORIES
  getCategories(type) {
    if (!type) {
      return [];
    }
    // Prodotti o Farmaci
    if (type === "prodotti" || type === "farmaci") {
      return _filter(this.props.categories, { type: type });
    }
    // TAG
    const tag = this.props.categoryTags.find((t) => t.name === type);
    if (tag) {
      return tag.categories;
    }
    return [];
  }

  // TOGGLE MEGA MENU
  toggleMegaMenu = (type) => (event) => {
    const { showMegaMenu, selectedMegaMenuType } = this.state;

    event.preventDefault();

    // Se è già aperto
    if (showMegaMenu) {
      if (selectedMegaMenuType !== type) {
        // Stiamo cliccando l'altro Link
        this.setState({
          selectedMegaMenuType: type,
        });
      } else {
        this.setState({
          showMegaMenu: false,
          selectedMegaMenuType: null,
        });
      }
    } else {
      // Chiuso => Aprire
      this.setState({
        showMegaMenu: true,
        selectedMegaMenuType: type,
      });
    }
  };

  getOptions = (input) => {
    return [];
  };

  getOptionsDebounced = debounce(this.getOptions, 500);

  getOptionsDoofinder = (input) => {
    return [];
  };

  getOptionsDoofinderDebounced = debounce(this.getOptionsDoofinder, 500);

  // LOGIN
  toggleLogin = (event) => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = (event) => {
    this.setState({
      showLogin: false,
    });
  };

  // MENU
  toggleHeaderMenu = (event) => {
    event.preventDefault();
    this.closeAll();

    const { singleStore, headerMenuOpen } = this.props;

    // singleStore(!headerMenuOpen);
  };

  // CART MENU
  toggleCartMenu = (event) => {
    event.preventDefault();
    this.closeAll();

    this.setState({
      showCartMenu: !this.state.showCartMenu,
    });
  };

  closeCartMenu = (event) => {
    this.setState({
      showCartMenu: false,
    });
  };

  // CLOSE ALL
  closeAll = (event) => {
    this.setState({
      showMegaMenu: false,
      selectedMegaMenuType: null,
      showCartMenu: false,
      showLogin: false,
      mobileCategory: null,
      mobileSubCategory: null,
    });
    // this.props.singleStore(false);
  };

  // RENDER
  renderSearchBox = () => {
    return (
      <div className="search-box">
        <AsyncSelect
          isHeader
          name="keyword-search"
          defaultOptions={[]}
          loadOptions={
            this.props.hasDoofinder
              ? this.getOptionsDoofinderDebounced
              : this.getOptionsDebounced
          }
          openOnClick={false}
          openOnFocus={false}
          autoload={false}
          onChange={(product) => {
            if (product.id > 0) {
              this.props.router.push(product.path);
            }
            if (product.id === -1) {
              this.props.router.push(`/ricerca/${product.searchKeywords}`);
            }
          }}
          optionRenderer={(product) => (
            <ProductAutocomplete
              product={product}
              primaryColor={this.props.primaryColor}
            />
          )}
          arrowRenderer={() => <Search />}
          filterOption={() => true}
          clearable={false}
          autosize={false}
          placeholder="Cerca nel sito"
          loadingPlaceholder="Caricamento..."
          searchPromptText="Digita il nome del prodotto"
        />
      </div>
    );
  };

  setMobileCategory = (mobileCategory) => {
    if (this.state.mobileCategory === mobileCategory) {
      this.setState({
        mobileCategory: null,
      });
    } else {
      this.setState({
        mobileCategory,
      });
    }
  };

  setMobileSubCategory = (mobileSubCategory) => {
    if (this.state.mobileSubCategory === mobileSubCategory) {
      this.setState({
        mobileSubCategory: null,
      });
    } else {
      this.setState({
        mobileSubCategory,
      });
    }
  };

  render() {
    const {
      showMegaMenu,
      showCartMenu,
      showLogin,
      selectedMegaMenuType,
    } = this.state;
    const {
      phone,
      user,
      isAuthenticated,
      onLogin,
      primaryColor,
      secondaryColor,
      hasBlog,
      couponPageUrl,
      loghiTemplate,
      loginError,
      categoryTags,
      freeShippingThreshold,
      headerMenuOpen,
      createUser,
      facebookAppId,
      hasFacebookLogin,
      hasDoofinder,
      doofinderHashId,
      uiVariantMenu,
      uiVariantInputText,
      store,
    } = this.props;

    const bottomMenuStyle = css`
      &.variant-1 {
        .desktop-menu a.link {
          margin: 0 10px;
          padding: 10px;
        }

        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primaryColor};
          font-size: 13px;
          background-color: ${primary_light(primaryColor)};
          border-radius: 12px;

          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
            background-color: ${primary_s98_l83(secondaryColor)};
          }
        }
      }

      &.variant-2 {
        .desktop-menu a.link {
          margin: 0 10px;
          padding: 10px 9px;
        }
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primaryColor};
          font-size: 13px;
          border-width: 1px;
          border-style: solid;
          border-color: ${primaryColor};

          &:focus,
          &:hover,
          &.active {
            color: #fff;
            background-color: ${primaryColor};
          }
        }
      }

      &.variant-3 {
        .desktop-menu a.link,
        .mobile-menu .user-section .open-login > a,
        .mobile-menu .user-section .welcome-user {
          color: ${primary_s15_l20(primaryColor)};
          font-size: 12px;
          text-transform: uppercase;

          &:focus,
          &:hover,
          &.active {
            color: ${primaryColor};
          }
        }

        .desktop-menu a.link {
          margin: 0 8px;

          &.active svg {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
          }

          svg {
            margin-left: 10px;
            transform: rotate(0);
            transition: all 0.3s ease-in-out;
          }
        }
      }

      .desktop-menu > a.link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        &:first-of-type {
          margin-left: 0;
        }
        &:last-of-type {
          margin-right: 0;
        }
      }

      .mobile-menu > a.link {
        &:focus,
        &:hover {
          color: ${primaryColor};
        }
      }
    `;

    // // console.log('store', store)
    return (
      <div className={`header-menu ${showMegaMenu ? "mega-menu-open" : ""}`}>
        <nav className="navbar navbar-expand-lg" role="navigation">
          {/* TOP MENU */}
          <div className="top">
            <div className="container container-wide">
              <div className="d-flex flex-row align-items-center justify-content-between">
                <div className="left-header">
                  <Button
                    type="button"
                    className="navbar-toggler"
                    data-toggle="collapse"
                    data-target="#menu"
                    aria-expanded="false"
                    onClick={this.toggleHeaderMenu}
                    style={{ color: primaryColor }}
                    disabled
                  >
                    <span className="sr-only">Toggle navigation</span>
                    {headerMenuOpen ? <FiX /> : <FiMenu />}
                  </Button>

                  <IndexLink
                    to="/"
                    onClick={() => console.log("")}
                    className="navbar-brand"
                    activeClassName="active"
                  >
                    <img src={logo} />
                  </IndexLink>
                </div>

                <div className="center-header">
                  {this.renderSearchBox()}
                  <div className="info-1">
                    <div className="icon" style={{ color: primaryColor }}>
                      <Spedizione />
                    </div>
                    <div className="text">
                      <div>{store.home.shippingDescription}</div>
                      <div>
                        <b>
                          Gratuita oltre{" "}
                          <Price amount={freeShippingThreshold} />
                        </b>
                      </div>
                    </div>
                  </div>
                  <div className="info-2">
                    <div className="icon" style={{ color: primaryColor }}>
                      <Assistenza />
                    </div>
                    <div className="text">
                      <div>
                        <b>
                          Assistenza Clienti{" "}
                          <a href="#" style={{ color: primaryColor }}>
                            035 000000
                          </a>
                        </b>
                      </div>
                      <div className="small">
                        Lunedì dalle 14.00 - 17,30
                        <br />
                        Martedì a Venerdì 9,00 - 12,30 14,30 - 17,30
                      </div>
                    </div>
                  </div>
                </div>

                <div className="right-header">
                  <CartMenu
                    showCartMenu={showCartMenu}
                    onToggleCartMenu={() => console.log("")}
                    onCloseCartMenu={this.closeCartMenu}
                    onCloseAll={this.closeAll}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* BOTTOM MENU */}
          <div
            className={`bottom variant-${uiVariantMenu}`}
            css={bottomMenuStyle}
          >
            {this.renderSearchBox()}
            <div
              className={`navbar-collapse collapse ${
                headerMenuOpen ? "show" : ""
              } justify-between`}
              id="menu"
            >
              <div className="container">
                <div className="desktop-menu">
                  {categoryTags &&
                    categoryTags.map((tag) => (
                      <Link
                        key={tag.name}
                        to="#"
                        className={`link ${
                          selectedMegaMenuType === tag.name ? "active" : ""
                        }`}
                        onClick={this.toggleMegaMenu(tag.name)}
                      >
                        {tag.name}
                        {uiVariantMenu === "3" && <FaChevronDown />}
                      </Link>
                    ))}

                  <Link
                    to="#"
                    className={`link ${
                      selectedMegaMenuType === "farmaci" ? "active" : ""
                    }`}
                    onClick={this.toggleMegaMenu("farmaci")}
                  >
                    Farmaci
                    {uiVariantMenu === "3" && <FaChevronDown />}
                  </Link>
                  <Link
                    to="#"
                    className={`link ${
                      selectedMegaMenuType === "prodotti" ? "active" : ""
                    }`}
                    onClick={this.toggleMegaMenu("prodotti")}
                  >
                    Prodotti
                    {uiVariantMenu === "3" && <FaChevronDown />}
                  </Link>
                </div>
              </div>

              <div className="mobile-menu">
                <div className="user-section">
                  <div className="container">
                    {!isAuthenticated ? (
                      <Login
                        user={user}
                        isAuthenticated={isAuthenticated}
                        onLogin={onLogin}
                        showLogin={showLogin}
                        onToggleLogin={this.toggleLogin}
                        onCloseLogin={this.closeLogin}
                        loginError={loginError}
                        primaryColor={primaryColor}
                        onCloseAll={this.closeAll}
                        isInMobileMenu
                        onLoginFacebook={this.props.onLoginFacebook}
                        facebookAppId={facebookAppId}
                        hasFacebookLogin={hasFacebookLogin}
                        createUser={createUser}
                        uiVariantInputText={uiVariantInputText}
                      />
                    ) : (
                      <Link
                        to="#"
                        className="welcome-user"
                        onClick={this.closeAll}
                      >
                        <LoginIcon /> Ciao{" "}
                        {user && user.billing && user.billing.firstname}
                      </Link>
                    )}
                  </div>
                </div>
                {!!this.getCategories("prodotti").length && (
                  <>
                    <a
                      href="#"
                      className="link"
                      onClick={() => this.setMobileCategory("prodotti")}
                      activeClassName="active"
                      style={{
                        borderBottom:
                          this.state.mobileCategory === "prodotti" ? 0 : "",
                      }}
                    >
                      <div className="container">Prodotti</div>
                    </a>
                    {this.state.mobileCategory === "prodotti" &&
                      this.props.categories
                        .filter((cat) => cat.type === "prodotti")
                        .map((category) => (
                          <>
                            <a
                              href="#"
                              className="link mobile-category"
                              activeClassName="active"
                            >
                              <div
                                onClick={() =>
                                  this.setMobileSubCategory(category.name)
                                }
                                className="container"
                                style={{ paddingLeft: 30, fontSize: 10 }}
                              >
                                {category.name}
                              </div>
                            </a>
                            {this.state.mobileCategory === "prodotti" &&
                              this.state.mobileSubCategory === category.name &&
                              category.subcategories.map((subcategory) => (
                                <Link
                                  to="#"
                                  className="link mobile-category"
                                  onClick={this.closeAll}
                                  activeClassName="active"
                                >
                                  <div
                                    className="container"
                                    style={{ paddingLeft: 45, fontSize: 10 }}
                                  >
                                    {subcategory.name}
                                  </div>
                                </Link>
                              ))}
                          </>
                        ))}
                  </>
                )}
                {!!this.getCategories("farmaci").length && (
                  <>
                    <a
                      href="#"
                      className="link"
                      onClick={() => this.setMobileCategory("farmaci")}
                      activeClassName="active"
                      style={{
                        borderBottom:
                          this.state.mobileCategory === "farmaci" ? 0 : "",
                      }}
                    >
                      <div className="container">Farmaci</div>
                    </a>
                    {this.state.mobileCategory === "farmaci" &&
                      this.props.categories
                        .filter((cat) => cat.type === "farmaci")
                        .map((category) => (
                          <>
                            <a
                              href="#"
                              className="link mobile-category"
                              activeClassName="active"
                            >
                              <div
                                onClick={() =>
                                  this.setMobileSubCategory(category.name)
                                }
                                className="container"
                                style={{ paddingLeft: 30, fontSize: 10 }}
                              >
                                {category.name}
                              </div>
                            </a>
                            {this.state.mobileCategory === "farmaci" &&
                              this.state.mobileSubCategory === category.name &&
                              category.subcategories.map((subcategory) => (
                                <Link
                                  to={`#`}
                                  className="link mobile-category"
                                  onClick={this.closeAll}
                                  activeClassName="active"
                                >
                                  <div
                                    className="container"
                                    style={{ paddingLeft: 45, fontSize: 10 }}
                                  >
                                    {subcategory.name}
                                  </div>
                                </Link>
                              ))}
                          </>
                        ))}
                  </>
                )}
                <Link
                  to="/prodotti-in-offerta"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Offerte</div>
                </Link>
                {!!hasBlog && (
                  <Link to="/blog" className="link" onClick={this.closeAll}>
                    <div className="container">Blog</div>
                  </Link>
                )}
                <Link
                  to="/pagine/contattaci"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Contatti</div>
                </Link>
                <Link
                  to="/pagine/servizi"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Servizi</div>
                </Link>
                <Link
                  to="/pagine/info-acquisti"
                  className="link"
                  onClick={this.closeAll}
                >
                  <div className="container">Info acquisti</div>
                </Link>
                {!!hasBlog && !!couponPageUrl && (
                  <A
                    className="link"
                    href={couponPageUrl}
                    onClick={this.closeAll}
                  >
                    <div className="container">Coupon</div>
                  </A>
                )}
              </div>
            </div>
          </div>
        </nav>

        <MegaMenu
          type={this.state.selectedMegaMenuType}
          showMegaMenu={showMegaMenu}
          categories={this.getCategories(this.state.selectedMegaMenuType)}
          onLinkClick={this.closeAll}
          primaryColor={primaryColor}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    store: state.store.singleStore,
    storeId: state.store.singleStore.storeId,
    categories: state.store.singleStore.categories,
    categoryTags: state.store.singleStore.categoryTags,
    facebookAppId: state.store.singleStore.facebook.appId,
    hasBlog: state.store.singleStore.hasBlog,
    hasFacebookLogin: state.store.singleStore.hasFacebookLogin,
    hasDoofinder: state.store.singleStore.hasDoofinder,
    doofinderHashId: state.store.singleStore.doofinder.hashId,
    couponPageUrl: state.store.singleStore.couponPageUrl,
    loghiTemplate: state.store.singleStore,
    phoneImage: state.store.singleStore.phoneImage,
    loginError: state.user.error,
    freeShippingThreshold:
      state.store.singleStore.costiSpedizione.freeShippingThreshold,
    headerMenuOpen: false,
    uiVariantMenu: state.store.singleStore.menu,
    uiVariantInputText: state.store.singleStore.inputText,
    primaryColor: state.store.singleStore.brandColor,
  };
}

export default withRouter(
  connect(mapStateToProps, { singleStore })(HeaderMenu)
);
